<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '实施信息'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="100px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="实施日期" prop="ImplementationAt">
            <el-date-picker
              v-model="item.ImplementationAt"
              style="width: 100%"
              type="date"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实施人员" prop="ImplementationPerson">
            <el-input
              v-model.trim="item.ImplementationPerson"
              placeholder="请输入实施人员"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="实施方式" prop="ImplementationType">
            <el-radio-group v-model="item.ImplementationType">
              <el-radio :label="0">现场实施</el-radio>
              <el-radio :label="1">远程实施</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实施内容" prop="ImplementationContent">
            <el-select
              v-model="item.ImplementationContent"
              :multiple-limit="6"
              multiple
              filterable
              default-first-option
              placeholder="请选择实施内容"
              style="width: 100%"
            >
              <el-option
                v-for="obj in implementationContentList"
                :key="obj.Key"
                :label="obj.Value"
                :value="obj.Key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="目的地" prop="ImplementationDest">
        <el-input
          v-model.trim="item.ImplementationDest"
          placeholder="请输入实施目的地"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="ImplementationRemark">
        <el-input
          v-model.trim="item.ImplementationRemark"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入实施备注"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :headers="uploadHeader"
          :file-list="fileList"
          :auto-upload="false"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-preview="handlePreview"
        >
          <el-button size="mini" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import FileSaver from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";

export default {
  components: {
    FileSaver,
    htmlDocx,
  },
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      uploadUrl: "api/dci/product/implementation/upload",
      fileList: [],
      removeList: [],
      implementationContentList: [{Key: 0, Value: "常规联网"},{Key: 1, Value: "流程调试"},{Key: 2, Value: "开发调试"}],
      attnum: 0,
      atttimes: 0,
      item: _.clone(this.value),
      rules: {
        ImplementationAt: [
          { required: true, message: "实施日期不能为空", trigger: "blur" },
        ],
        ImplementationPerson: [
          { required: true, message: "实施人员不能为空", trigger: "blur" },
        ],
        ImplementationType: [
          { required: true, message: "实施方式不能为空", trigger: "blur" },
        ],
        ImplementationContent: [
          { required: true, message: "实施内容不能为空", trigger: "blur" },
        ],
        ImplementationDest: [
          { required: true, message: "目的地不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      if (this.item.ImplementationAttachments) {
          this.item.ImplementationAttachments.forEach((ele) => {
            const file = {};
            // file.id = ele.ID;
            file.name = ele.Name;
            file.url = ele.Url;
            this.fileList.push(file);
          });
        } else {
          this.item.ImplementationAttachments = [];
        }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.removeList = [];
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }

        this.submitting = true;

        this.attnum = 0; //有没有新上传附件
        this.$refs.upload.uploadFiles.forEach((item) => {
          if (item.status === "ready") {
            this.attnum += 1;
          }
        });
        if (this.attnum > 0) {
          this.atttimes = 0;
          this.$refs.upload.uploadFiles.map((item) => item.status === "ready");
          this.$refs.upload.submit();
        } else {
          this.lastSubmit();
        }
      });
    },
    lastSubmit() {
      if (this.removeList.length !== 0) {
        this.removeList.forEach((ele) => {
          this.item.ImplementationAttachments.splice(
            this.item.ImplementationAttachments.findIndex(
              (item) => item.Url === ele
            ),
            1
          );
        });
        this.$axios.delete("dci/product/implementation/dispose", {
          data: { file: this.removeList },
        });
      }

      this.$axios
        .request({
          url: this.item.ID
            ? `dci/product/implementation/${this.item.ID}`
            : "dci/product/implementation",
          method: this.item.ID ? "put" : "post",
          data: this.item,
        })
        .then(() => {
          this.$message.success("操作成功");
          this.submitting = false;
          this.$emit("form:saved", true);
          this.$emit("form:done", true);
          this.onClose();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
        });
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.removeList = [];
    },
    handleSuccess(response) {
      if (this.item.ImplementationAttachments === null) {
        this.item.ImplementationAttachments = [];
      }
      this.item.ImplementationAttachments.push(response);
      this.atttimes += 1; //第几次调用改方法（每个文件都会调用一次，最后一次再触发保存）

      if (this.atttimes === this.attnum) {
        this.lastSubmit();
      }
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
    handleRemove(file) {
      if (file.status === "success") {
        this.removeList.push(file.url);
      }
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
  },
};
</script>
